<script context="module">
    import { env } from '../Environment.svelte';

    export async function fetchMunicipality(postalCode) {
        var myHeaders = new Headers();
        myHeaders.append('x-api-key', env[env.stage].api.key);
        myHeaders.append('Content-Type', 'application/json');

        var graphql = JSON.stringify({
            query:
                `
    {
        municipality(postalCode: "` +
                postalCode +
                `") {
            municipality
        }
    }
    `,
            variables: {},
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow',
        };
        const response = await fetch(
            env[env.stage].api.url + 'izziweb/ms/offer/graphql',
            requestOptions
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Error al consumir el servicio');
                }
            })
            .then((result) => {
                return result.data.municipality;
            })
            .catch((error) => {
                console.error(error);
                return error;
            });
        return await response;
    }

    export async function fetchAddresses(postalCode, addressQuery) {
        var myHeaders = new Headers();
        myHeaders.append('x-api-key', env[env.stage].api.key);
        myHeaders.append('Content-Type', 'application/json');

        var graphql = JSON.stringify({
            query:
                `
    {
        addresses(addressQuery: "` +
                addressQuery +
                `", postalCode: "` +
                postalCode +
                `") {
            addresses {
                id
                value
                label
                rpt
                estado
                delegacion
                colonia
                calle
                numero
                interior
                latitud
                longitud
            }
        }
    }
    `,
            variables: {},
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow',
        };
        const response = await fetch(
            env[env.stage].api.url + 'izziweb/ms/offer/graphql',
            requestOptions
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Error al consumir el servicio');
                }
            })
            .then((result) => {
                return result.data.addresses;
            })
            .catch((error) => {
                console.error(error);
                return error;
            });
        return await response;
    }

    export async function fetchOffNet(postalCode) {
        let myHeaders = new Headers();
        myHeaders.append('x-api-key', env[env.stage].api.key);
        myHeaders.append('Content-Type', 'application/json');

        let requestBody = JSON.stringify({
            nodeCP: postalCode,
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: requestBody,
        };

        const response = await fetch(
            env[env.stage].api.url +
                'apikey/izzi/ms/purchaseServices/purchase/atomic/validateOffnet',
            requestOptions
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Error al consumir el servicio de offnet');
                }
            })
            .then((result) => {
                if (result.status != '200') {
                    return null;
                }
                return result.dataArea.Item.MUNICIPIO;
            })
            .catch((error) => {
                return error;
            });
        return await response;
    }
</script>
